import { render, staticRenderFns } from "./ImportContactsFromExcelFileModal.vue?vue&type=template&id=04946827&scoped=true"
import script from "./ImportContactsFromExcelFileModal.vue?vue&type=script&lang=ts"
export * from "./ImportContactsFromExcelFileModal.vue?vue&type=script&lang=ts"
import style0 from "./ImportContactsFromExcelFileModal.vue?vue&type=style&index=0&id=04946827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04946827",
  null
  
)

export default component.exports